import React from 'react';
import FeatureFlagContext from './FeatureFlagContext'
import AppHelper from 'js/app/AppHelper';

class FeatureFlagView extends React.Component {
  render () {
    const features = AppHelper.getAppData("featureToggles")
   
    return (
      <FeatureFlagContext.Provider value={features}>
        {this.props.children}
      </FeatureFlagContext.Provider>
    )
  }
}

 export default FeatureFlagView